import React, { useEffect } from 'react';

import { connect } from 'react-redux';

import FullScreenLogo from 'components/FullScreenLogo';

import { fetchTranslations } from 'store/modules/translations';

const loadTranslationsHook = ({
  fetchTranslations,
  locale,
  shouldLoadTranslations,
}) => {
  if (shouldLoadTranslations) {
    fetchTranslations(locale);
  }
};

const Children = ({
  children,
  fetchTranslations,
  locale,
  loaded,
  messages,
  shouldLoadTranslations,
}) => {
  useEffect(
    () =>
      loadTranslationsHook({
        fetchTranslations,
        locale,
        shouldLoadTranslations,
      }),
    [fetchTranslations, locale, shouldLoadTranslations],
  );

  return loaded ? children(locale, messages) : <FullScreenLogo />;
};

const mapStateToProps = ({ translations: { messages, loading, loaded } }) => ({
  messages,
  loaded,
  shouldLoadTranslations: !loading && !loaded,
});

const mapDispatchToProps = {
  fetchTranslations,
};

export default connect(mapStateToProps, mapDispatchToProps)(Children);
